import { Box } from "@vinomofo/components";

import { ContentBlock } from "../../component-factory/content-block";
import { BannerProps } from "../banner";

export const BannerHero = ({
  banner,
}: {
  banner: BannerProps;
}): JSX.Element => {
  return (
    <Box display="flex" width="100%" height={["420px", "600px", "600px"]}>
      <ContentBlock {...banner} hero />
    </Box>
  );
};
